import React, { useEffect, useRef, useState } from 'react';
import '../../styles/PartnerWithUs.css';

function RedQuoteBlock() {
  const quoteRef = useRef();
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = quoteRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.3 }
    );

    observer.observe(node);

    return () => {
      if (node) observer.unobserve(node);
    };
  }, []);

  return (
    <blockquote
      ref={quoteRef}
      className={`redQuote fade-in${inView ? ' in-view' : ''}`}
    >
      “YES, I'm ready to join you guys!”
    </blockquote>
  );
}

export default RedQuoteBlock;
